var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIconLiveEventsTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-daily-insights-03") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,5.91A17,17,0,0,0,6,1V3A14.91,14.91,0,0,1,16.54,7.33,15.11,15.11,0,0,1,21,18h2A17.19,17.19,0,0,0,18,5.91Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6,5V7a10.93,10.93,0,0,1,7.73,3.18A11.08,11.08,0,0,1,17,18h2a13.09,13.09,0,0,0-3.85-9.24A13,13,0,0,0,6,5Z",
    fill: "#343434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6,9v2a7,7,0,0,1,4.93,2A7.11,7.11,0,0,1,13,18h2A9,9,0,0,0,6,9Z",
    fill: "#343434"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6,13a5,5,0,1,0,3.53,1.46A5,5,0,0,0,6,13Zm0,8a3,3,0,1,1,3-3A3,3,0,0,1,6,21Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIconLiveEventsTracker);
export default __webpack_public_path__ + "static/media/navigation-icon-live-events-tracker.d4951ec33eb581b5aa5664404213f5c2.svg";
export { ForwardRef as ReactComponent };